import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { VehiclesService } from "../vehicles.service";

@Component({
  selector: "app-add-and-edit-vehicle",
  templateUrl: "./add-and-edit-vehicle.component.html",
  styleUrls: ["./add-and-edit-vehicle.component.sass"],
})
export class AddAndEditVehicleComponent {
  @Input() vehicleData: any = null;
  @Output() formSubmitted = new EventEmitter<any>();
  @ViewChild("modal") modalRef!: ElementRef;

  vehicleForm: FormGroup;

  showModal = false;

  constructor(
    private fb: FormBuilder,
    private vehiclesService: VehiclesService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
  ) {
    this.vehicleForm = this.fb.group({
      truckType: ["", Validators.required],
      image: ["", [Validators.required, Validators.pattern("https?://.+")]], // basic URL check
      vehicleLength: [
        "",
        [Validators.required, Validators.pattern("^[0-9]+(\\.[0-9]+)?$")],
      ], // numbers with optional decimals
      vehicleBreadth: [
        "",
        [Validators.required, Validators.pattern("^[0-9]+(\\.[0-9]+)?$")],
      ],
      vehicleHeight: [
        "",
        [Validators.required, Validators.pattern("^[0-9]+(\\.[0-9]+)?$")],
      ],
      truckTyres: ["", Validators.required],
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["vehicleData"] && this.vehicleData) {
      this.vehicleForm.patchValue(this.vehicleData);
      this.imagePreview = this.vehicleData.image || null;
    }
  }

  open(vehicle: any = null) {
    this.vehicleData = vehicle;
    this.showModal = true;

    if (vehicle) {
      this.vehicleForm.patchValue(vehicle);
    } else {
      this.vehicleForm.reset();
    }
  }

  close() {
    this.showModal = false;
  }

  submitForm() {
    if (this.vehicleForm.valid) {
      this.spinner.show();

      const vehicleData = {
        truckType: this.vehicleForm.get("truckType")?.value,
        image: this.vehicleForm.get("image")?.value,
        vehicleLength: this.vehicleForm.get("vehicleLength")?.value,
        vehicleBreadth: this.vehicleForm.get("vehicleBreadth")?.value,
        vehicleHeight: this.vehicleForm.get("vehicleHeight")?.value,
        truckTyres: this.vehicleForm.get("truckTyres")?.value,
      };

      const request$ = this.vehicleData
        ? this.vehiclesService.updateVehicle(this.vehicleData._id, vehicleData)
        : this.vehiclesService.addVehicle(vehicleData);

      request$.subscribe({
        next: (res: any) => {
          this.toastr.success(
            res.message ||
              (this.vehicleData
                ? "Vehicle updated successfully"
                : "Vehicle added successfully")
          );
          this.formSubmitted.emit(vehicleData);
          this.close();
          this.spinner.hide();
        },
        error: (err) => {
          console.error("Vehicle save failed:", err);
          this.toastr.error(err.message || "Something went wrong");
          this.spinner.hide();
        },
      });
    } else {
      this.vehicleForm.markAllAsTouched();
    }
  }

  imagePreview: string | null = null;
  imageUploadError: string | null = null;

  onImageSelected(event: any): void {
    const file: File = event.target.files[0];

    if (!file) return;

    // Optional: Validate file type and size
    const allowedTypes = ["image/jpeg", "image/png"];
    if (!allowedTypes.includes(file.type)) {
      this.imageUploadError = "Invalid file type. Only JPEG, PNG allowed.";
      return;
    }

    this.imageUploadError = null;
    this.spinner.show();
    this.vehiclesService.addImage(file).subscribe({
      next: (res: any) => {
        console.log("img", res);
        const uploadedUrl = res?.photoUrl; // Adjust this based on your actual API response
        this.spinner.hide();
        this.toastr.success(res.message);
        if (uploadedUrl) {
          this.vehicleForm.patchValue({ image: uploadedUrl });
          this.imagePreview = uploadedUrl;
        } else {
          this.imageUploadError = "Upload failed: No URL returned.";
        }
      },
      error: () => {
        this.imageUploadError = "Image upload failed. Try again.";
      },
    });
  }
}
